import React, { Fragment } from 'react';
import Head from 'compat/Head';
import { ThemeProvider } from 'styled-components';
import { theme } from 'common/theme/appCreative';
import ResetCSS from 'common/assets/css/style';
import Sticky from 'react-stickynode';
import Navbar from 'containers/AppCreative/Navbar';
import PagesBanner from 'containers/AppCreative/PagesBanner';
import Footer from 'containers/AppCreative/Footer';
import GlobalStyle, { AppWrapper, ContentWrapper } from 'containers/AppCreative/appCreative.style';
import bannerImg from 'common/assets/image/appCreative/bannerImg_contact.png';
import GetStarted from 'containers/AppCreative/GetStarted';

export default function GetStartedPage() {
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Head>
          <title>Request a Demo | Linok: From Data to Decisions</title>
          <link rel="icon" href="/favicon.png" />
          <meta name="description" content="Request a demo of Linok - revolutionize your dairy management with real-time data analytics and insights. Fill out the form and our team will reach out to you." />
          <meta name="theme-color" content="#156b83" />
          <meta name="keywords" content="Linok, dairy, farming, data, sensors, demo, request a demo" />
        </Head>
        <ResetCSS />
        <GlobalStyle />
        <AppWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-active">
            <Navbar />
          </Sticky>
          <ContentWrapper>
            <PagesBanner
              title={'Request a Demo'}
              subtitle={'Ready to transform your dairy operation? Tell us about your farm and our team will reach out to schedule a demo.'}
              bannerImg={bannerImg}
            />
            <GetStarted />
          </ContentWrapper>
          <Footer />
        </AppWrapper>
      </Fragment>
    </ThemeProvider>
  );
}
